import { render, staticRenderFns } from "./sortform.vue?vue&type=template&id=738179bf&scoped=true&"
import script from "./sortform.vue?vue&type=script&lang=js&"
export * from "./sortform.vue?vue&type=script&lang=js&"
import style0 from "./sortform.vue?vue&type=style&index=0&id=738179bf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738179bf",
  null
  
)

export default component.exports